// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"47924b75","732":"cf139418","977":"bece66b4"}[chunkId] + ".chunk.js";
};